import { MutationCache, QueryClient } from '@tanstack/react-query';
import { getAuthentication } from 'shared/services/backend-api/helpers';
import { getErrorReporter, wasReported } from 'shared/services/error-tracking';

import { getMutationErrorContext } from './get-mutation-error-context';
import { isExpectedMutationError } from './is-expected-mutation-error';

const mutationCache = new MutationCache({
  onError: async (error, variables, _context, mutation) => {
    if (isExpectedMutationError(error) || wasReported(error)) {
      return;
    }

    const auth = await getAuthentication();
    const uid = auth.currentUser?.uid;
    const errorContext = getMutationErrorContext(
      error,
      variables,
      mutation,
      uid,
    );

    getErrorReporter().captureException(error, {
      tags: {
        uid,
        source: 'tanstack-mutation',
        errorKind: errorContext.errorKind,
        firestoreCode: errorContext.firestoreCode ?? undefined,
      },
      contexts: { mutation: errorContext },
    });
  },
});

export const queryClient = new QueryClient({
  mutationCache,
  defaultOptions: {
    mutations: {
      networkMode: 'offlineFirst',
    },
    queries: {
      staleTime: Infinity,
      gcTime: 60 * 60 * 1000,
      suspense: true,
      networkMode: 'offlineFirst',
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  },
});
